import React from 'react'
import { useHeader, HeaderProps } from './useHeader'
import styles from './Header.module.scss'
import logoImg from 'img/logo.webp'

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { navLinks, activeSection, isMobileNavActive, toggleMobileNav } =
    useHeader(props)

  return (
    <header
      id='header'
      className={`${styles.header} ${
        isMobileNavActive ? styles['mobile-nav-active'] : ''
      } d-flex align-items-center fixed-top`}
    >
      <div
        className={`${styles['header-container']} container-fluid container-xl position-relative d-flex align-items-center justify-content-between`}
      >
        <a
          href='#hero'
          className={`${styles.logo} d-flex align-items-center me-auto me-xl-0`}
        >
          <img src={logoImg} alt='logo' />
        </a>

        <nav id='navmenu' className={styles.navmenu}>
          <ul>
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => toggleMobileNav(false)}
                  className={
                    activeSection === link.href.substring(1)
                      ? styles.active
                      : ''
                  }
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <i
            className={`${styles['mobile-nav-toggle']} d-xl-none bi ${
              isMobileNavActive ? 'bi-x' : 'bi-list'
            }`}
            onClick={() => toggleMobileNav()}
          ></i>
        </nav>

        <a className={`${styles['btn-getstarted']}`} href='#pricing'>
          Get Started
        </a>
      </div>
    </header>
  )
}

export default Header
